import { ProductService } from '@app-core/services';
import { fetchFilters } from '@app-core/utils/fetch-filters';
import { filterProducts } from '@app-core/utils/filter-products';
import { ProductFilters } from '@app-model/filters/product-filters';
import { Markup } from '@app-model/login';
import { GetProductsRequest } from '@app-model/request';
import { GetProductsResponse, ProductItem } from '@app-model/response';

import * as ProductActions from './product.actions';

export interface State {
  error: string;
  filters: ProductFilters;
  visibleProducts: ProductItem[];
  markup: Markup;
  allProducts: ProductItem[];
  response: GetProductsResponse;
  request: GetProductsRequest;
  successful: boolean;
}

const InitialState: State = {
  error: '',
  filters: new ProductFilters(),
  visibleProducts: null,
  markup: new Markup(),
  allProducts: null,
  response: null,
  request: null,
  successful: false,
};

export function reducer(state = InitialState, action: ProductActions.All): State {
  switch (action.type) {
    case ProductActions.GET_PRODUCTS: {
      return { ...state, request: action.payload, error: '' };
    }

    case ProductActions.CHANGE_MARKUP: {
      const allProducts = ProductService.productResponseDataMapper(state.allProducts, action.payload.markup);
      const visibleProducts = filterProducts(state.filters, allProducts);

      return { ...state, markup: action.payload.markup, allProducts, visibleProducts };
    }

    case ProductActions.GET_PRODUCTS_SUCCESS: {
      const products = action.response.availableOptions.products.productItem;
      const filters = fetchFilters(products);
      const allProducts = ProductService.productResponseDataMapper(products, action.markup);
      const visibleProducts = filterProducts(filters, allProducts);

      return {
        ...state,
        error: '',
        filters,
        visibleProducts,
        markup: action.markup,
        allProducts,
        response: action.response,
        successful: true,
      };
    }

    case ProductActions.ADD_MARKUP_TO_COST: {
      return { ...state, visibleProducts: action.payload.grid, markup: action.payload.markup };
    }

    case ProductActions.GET_PRODUCTS_FAILURE: {
      return { ...state, response: undefined, error: action.payload.error, successful: false };
    }

    case ProductActions.FILTER_GRID_SUCCESS: {
      const markupProducts = ProductService.productResponseDataMapper(action.payload.grid, state.markup);

      return { ...state, visibleProducts: markupProducts, filters: action.payload.filters };
    }

    case ProductActions.LOAD_PRODUCT_QUOTE: {
      return {
        ...state,
        allProducts: action.payload.gridProducts,
        filters: action.payload.filters,
        visibleProducts: action.payload.gridProducts,
        markup: action.payload.markup,
        response: action.payload.response,
        request: action.payload.request,
        successful: true,
      };
    }

    case ProductActions.SORT_GRID: {
      return { ...state, visibleProducts: [...action.payload] };
    }

    case ProductActions.RESET_PRODUCTS: {
      return {
        error: '',
        filters: new ProductFilters(),
        visibleProducts: undefined,
        markup: new Markup(),
        allProducts: undefined,
        response: undefined,
        request: null,
        successful: false,
      };
    }

    case ProductActions.APPLY_FILTERS: {
      return { ...state, visibleProducts: filterProducts(action.filters, state.allProducts) };
    }

    default: {
      return state;
    }
  }
}
